(function () {
  function initParallaxNav(section) {
    const nav = section.querySelector('[data-aw-parallax-nav]');
    const list = nav && nav.querySelector('.aw-hero-parallax__nav-list');
    const cta = nav && nav.querySelector('[data-aw-parallax-cta]');
    if (!list) return;

    const panels = Array.from(section.querySelectorAll('[data-aw-panel]'));
    if (!panels.length) return;

    // Reset nav list
    list.innerHTML = '';

    // Build nav items from panel data attributes
    panels.forEach((panel, i) => {
      const li = document.createElement('li');
      li.className = 'aw-hero-parallax__nav-item';
      li.dataset.navIndex = i;
      li.textContent = panel.dataset.collectionTitle || 'Collection';
      li.addEventListener('click', () => {
        const url = panel.dataset.collectionUrl;
        if (url) window.location.href = url;
      });
      list.appendChild(li);
    });

    function setActive(index) {
      const items = list.querySelectorAll('.aw-hero-parallax__nav-item');
      items.forEach((item, i) => {
        const dist = Math.abs(i - index);
        item.classList.toggle('is-active', i === index);
        item.dataset.distance = dist > 2 ? '3' : String(dist);
      });
      if (cta) {
        cta.href = panels[index].dataset.collectionUrl || '#';
      }
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = panels.indexOf(entry.target);
            if (index !== -1) setActive(index);
          }
        });
      },
      { threshold: 0.5 }
    );

    panels.forEach((panel) => observer.observe(panel));
    setActive(0);
  }

  function init(root = document) {
    root.querySelectorAll('[data-aw-hero-parallax]').forEach(initParallaxNav);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
